import { USER_FORGOT_PASSWORD_REQUEST, USER_FORGOT_PASSWORD_SUCCESS, USER_FORGOT_PASSWORD_FAILURE } from '../constants/password.constants';

const initialState = {
    isSendingEmail: false,
    hasSentEmail: false,
    error: null,
};

export const Forgot_password_form = (state = initialState, action) => {
    switch (action.type) {
    case USER_FORGOT_PASSWORD_REQUEST:
        return {
            ...state,
            isSendingEmail: true,
            hasSentEmail: false,
        };
    case USER_FORGOT_PASSWORD_SUCCESS:
        return {
            ...state,
            isSendingEmail: false,
            hasSentEmail: true,
        };
    case USER_FORGOT_PASSWORD_FAILURE:
        return {
            ...state,
            isSendingEmail: false,
            hasSentEmail: false,
            error: action.error,
        };
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/App/redux/reducers/forgot_password.reducers.js